import digitalmarketingone from "../assets/digitalmarketing/digitalmarkeingimgone.jpeg";
import digitalmarketingtwo from "../assets/digitalmarketing/digitalmarkeingimgtwo.jpeg";
import digitalmarketingthree from "../assets/digitalmarketing/digitalmarkeingimgthree.jpeg";
import digitalmarketingfour from "../assets/digitalmarketing/digitalmarkeingimgfour.jpeg";



const DigitalMarketing = [
  {
    icon: digitalmarketingone,
    // path: "Web-Development",
  },

  {
    icon: digitalmarketingtwo,
    // path:"Digital-Marketing"
  },

  {
    icon: digitalmarketingthree,
    // path:"Web-Services"
  },
  {
    icon: digitalmarketingfour,
    // path:"Web-Services"
  },
];

export default DigitalMarketing;
